import React, { useState, useMemo } from "react";
import { makeStyles, Grid, Button, Chip } from "@material-ui/core";
import { Select } from "../../../Common/Select";
import { Header, ConcludeButtonContainer } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    borderRadius: 25,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const ExportMinuteFileModal = ({
  t,
  setExportMinuteFileModalOpened,
  handleExportMinuteFile,
  minuteCompaniesForExportFile,
}) => {
  const classes = useStyles();

  const [selectedCompanies, setSelectedCompanies] = useState([]);

  const companyOptions = useMemo(() => {
    return minuteCompaniesForExportFile?.map((item) => ({
      id: item.companyId,
      name: `${item.companyName} - ${item.companyAbbreviation}`,
      abbreviation: item.companyAbbreviation,
    }));
  }, [minuteCompaniesForExportFile]);
  const exportMinuteFile = async () => {
    handleExportMinuteFile(selectedCompanies);
  };

  return (
    <>
      <div
        style={{ minHeight: "400px", display: "flex", flexDirection: "column" }}
      >
        <Header>
          <div>
            <span
              style={{ float: "right", cursor: "pointer" }}
              onClick={() => {
                setExportMinuteFileModalOpened(false);
              }}
            >
              [X] Fechar
            </span>

            <span className={classes.titleModal}>
              {t("forms.minutes.exportMinuteFileQuestion")}
            </span>
          </div>
        </Header>

        <Grid container spacing={3}>
          <Grid item lg={12} xs={12}>
            <Select
              id="companies"
              options={[...companyOptions]}
              getOptionSelected={(option, value) => option.id === value.id}
              value={selectedCompanies}
              label={t("slots.companies")}
              setValue={(values) => {
                setSelectedCompanies(values);
              }}
              required={companyOptions?.length > 0}
              error={
                companyOptions?.length > 0 && selectedCompanies.length === 0
              }
              multiple={true}
              disabled={companyOptions?.length === 0}
              renderTags={(selectedValues) => {
                return selectedValues.map((option) => (
                  <Chip
                    className={classes.chip}
                    key={option.id}
                    onDelete={() => {
                      setSelectedCompanies(
                        selectedCompanies.filter((v) => v.id !== option.id)
                      );
                    }}
                    onClick={() => {
                      setSelectedCompanies(
                        selectedCompanies.filter((v) => v.id !== option.id)
                      );
                    }}
                    variant="outlined"
                    label={option.name}
                  />
                ));
              }}
            />
          </Grid>
        </Grid>

        <ConcludeButtonContainer>
          <Button
            className={classes.buttonOutlined}
            variant="outlined"
            onClick={() => setExportMinuteFileModalOpened(false)}
          >
            {t("forms.committee.buttons.cancel")}
          </Button>
          <Button
            className={classes.button}
            variant="contained"
            onClick={exportMinuteFile}
          >
            {t(
              "softwareManagement.modules.groups.functionalities.exportMinute"
            )}
          </Button>
        </ConcludeButtonContainer>
      </div>
    </>
  );
};

export default ExportMinuteFileModal;
